export default class TabCarouselBind {
  init () {
    $('.c_nav[data-bind-to]').each(function () {
      const $this = $(this);
      const carouselId = $this.data('bind-to');
      const $carousel = $(`#${carouselId}`);

      // 対応するカルーセルが変わったらタブも変更
      $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const tabSelector = '.c_nav_tab';
        const $tab = $this.children(tabSelector);
        $tab.removeClass('is_current');
        const $targetTab = $(`${tabSelector}[data-carousel-index="${nextSlide}"]`);
        const $navTabItem = $this.next().children('.c_nav_tab_item');
        $navTabItem.hide();
        if ($targetTab.length) {
          $targetTab.addClass('is_current');
          $navTabItem.eq($tab.index($targetTab)).show();
        } else {
          $tab.eq(nextSlide).addClass('is_current');
          $navTabItem.eq(nextSlide).show();
        }
      });

      // タブが変わったら対応するカルーセルも変更
      $this.find('.c_nav_tab').on('click', function () {
        const $this = $(this);
        const tabIndex = $this.closest('.c_nav').find('.c_nav_tab').index($this);
        const carouselIndex = $this.data('carousel-index') === undefined ? tabIndex : $this.data('carousel-index');
        $carousel.slick('slickGoTo', carouselIndex);
        const $tabItem = $this.closest('.c_nav').next('ul').children('.c_nav_tab_item');
        $tabItem.hide();
        $tabItem.eq(tabIndex).show();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/modules/tab_carousel_bind.js